export interface DxSourceTypeOption {
  id: string;
  label: string;
}

/**
 * Builds the Type dropdown options from a facility's `dx_source_policy`:
 * one option per policy key, in the policy's own key order. The facility
 * policy is the single source of truth — no sources are hardcoded here.
 *
 * @param policy - Facility `dx_source_policy` (e.g. `{ CMS, Custom, NCCN }`)
 * @returns One option per policy key; empty when no policy is set
 */
export const getDxSourceTypeOptions = (
  policy: Record<string, boolean> | undefined,
): DxSourceTypeOption[] =>
  Object.keys(policy ?? {}).map((id) => ({ id, label: id }));
